import { render, staticRenderFns } from "./ResourceTag.vue?vue&type=template&id=6852029f&scoped=true"
import script from "./ResourceTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResourceTag.vue?vue&type=style&index=0&id=6852029f&prod&scoped=true&lang=css"
import style1 from "./ResourceTag.vue?vue&type=style&index=1&id=6852029f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6852029f",
  null
  
)

export default component.exports